export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/james-f803982222c87392f69787c2a3899de6.jpg";